module.exports = __webpack_public_path__ + "img/oursolution2.18083111.png";